import { Component, computed, effect } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet,
} from '@angular/router';
import { filter, Observable } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ToastDrawerComponent } from 'mt-ui-lib/components/toast/toast-drawer';
import { ThemeService } from './core/services/theme.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, ToastDrawerComponent],
})
export class AppComponent {
  private readonly darkThemeOn = [
    'auth',
    'main',
    'recovery',
    'change-password',
    'page-not-found',
    'no-access',
    'administration-required',
    'account',
  ];
  private readonly navigationEnd = toSignal<NavigationEnd>(
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
    ) as Observable<NavigationEnd>,
  );

  protected readonly title = computed(() => {
    const _ = this.navigationEnd();
    let child = this.activatedRoute?.firstChild ?? null;

    while (child?.firstChild) {
      child = child.firstChild;
    }

    if (child?.snapshot?.data['titleKey']) {
      return this.translateService.instant(child.snapshot.data['titleKey']);
    }

    if (child?.snapshot?.data['title']) {
      return child.snapshot.data['title'];
    }

    return null;
  });

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translateService: TranslateService,
    private themeService: ThemeService,
  ) {
    // effect(() => {
    //   const title = this.title();
    //   this.titleService.setTitle(title);
    // });

    effect(() => {
      const ne = this.navigationEnd();
      const url = ne?.urlAfterRedirects ?? ne?.url ?? null;

      if (!url) {
        return;
      }

      if (url === '/') {
        this.themeService.setDarkTheme();

        return;
      }

      const isDarkTheme = this.darkThemeOn.some((path) => url.includes(path));

      if (isDarkTheme) {
        this.themeService.setDarkTheme();
      } else {
        this.themeService.setUserTheme();
      }
    });
  }
}
